import { APITransport } from '@client/transports/api';

// Login rejects bad credentials, unverified emails, and accounts with no active domain
// with a 4xx. Those are expected user conditions surfaced to the UI, not app faults, so
// they stay breadcrumbs only — 5xx/network still capture as real incidents.
export const UserService = {
  get(token) {
    return APITransport.post({
      path: '/rest/login',
      body: {
        token
      },
      ignoreClientErrors: true
    });
  },
  login(username, password) {
    return APITransport.post({
      path: '/rest/login',
      body: {
        username,
        password
      },
      cancellable: false,
      ignoreClientErrors: true
    });
  },
  switch(token, domain) {
    return APITransport.post({
      path: '/rest/login',
      body: {
        token,
        switchDomain: domain
      },
      cancellable: false,
      ignoreClientErrors: true
    });
  }
};
